/*$Id$*/
/* ANGULAR COMPONENTS */
import { NgModule, Compiler, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule, NgbActiveModal, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { Router, Routes, RouterModule} from '@angular/router';

import { GlobalVariable } from 'app/app.global';
import { ALL_ROUTES } from 'app/app.routes';

/* SERVICES */
import { OfferBannerService } from 'app/services/offer.banner.service';
import { AuthenticationService } from 'app/services/authentication.service';
import { AdministrationService } from 'app/services/administration.service';
import { ConsumeService } from 'app/services/consume.service';
import { GroupService } from 'app/services/group.service';
import { BlockGroupService } from 'app/services/block.group.service';
import { PackagesService } from 'app/services/packages.service';
import { CalendarService } from 'app/services/calendar.service';
import { VivoSyncService } from 'app/services/vivo.sync.service';
import { ProcAsyncReportService } from './services/reports.procasync.service';

import { ConsumptionReportService } from 'app/services/reports.consumption.service';
import { OperationsReportService } from 'app/services/reports.operations.service';
import { CallHistoryReportService } from 'app/services/reports.callhistory.service';
import { VoiceConsumeService } from './services/voice.consume.service';

/* UTILS */
import { AlertService } from 'app/utils/alert.service';
import { BindComponentService } from 'app/utils/bind.component.service'
import { NgbAlert } from 'app/utils/alert.component';
import { CustomNgbDateParserFormatter } from 'app/utils/custom.ngbdateparserformatter';
import { CustomNgbDatepickerI18n } from 'app/utils/custom.ngbdatepickeri18n';
import { PipeModule } from 'app/utils/pipe/pipe.module';
import { MaskCurrencyDirective } from 'app/utils/directives/masked-input/mask.currency.directive';

/* COMPONENTS */
import { MainComponent } from 'app/home/main.component';
import { HeaderComponent } from 'app/home/paraEmpresas/header/header.component';
import { FooterComponent } from 'app/home/paraEmpresas/footer/footer.component';
import { BreadcrumbComponent } from 'app/utils/breadcrumb.component';
import { LoadingComponent } from 'app/home/paraEmpresas/modalLoading/content.component';
import { Mobilesearch } from 'app/home/paraEmpresas/header/mobilesearch/content.component';
//LOGIN
import { LoginComponent } from  'app/home/paraEmpresas/login/content.component';
//STEPS
import { StepsComponent } from 'app/home/paraEmpresas/steps/content.component';
//ADMINISTRATION
import { AdministrationComponent } from 'app/home/paraEmpresas/administration/content.component';
import { RemoveAdministratorComponent } from 'app/home/paraEmpresas/administration/remove/content.component';
import { EditAdministratorComponent } from 'app/home/paraEmpresas/administration/save/content.component';
import { ListAdministratorComponent } from 'app/home/paraEmpresas/administration/list/content.component';
import { AbbreviatedDialingComponent } from 'app/home/paraEmpresas/administration/abbreviatedDialing/content.component';
import { RemoveServiceMemberComponent } from 'app/home/paraEmpresas/administration/abbreviatedDialing/remove/content.component';
//CONSUMPTION
import { ConsumeComponent } from 'app/home/paraEmpresas/consume/content.component';
import { ConsumeDataComponent } from './home/paraEmpresas/consume/data/content.component';
import { ConsumeDataComponent5G } from './home/paraEmpresas/consume/data5G/content.component';


import { SaveConsumeComponent } from 'app/home/paraEmpresas/consume/save/content.component';
import { RemoveGroupConsumeComponent } from 'app/home/paraEmpresas/consume/remove/content.component';
import { MoveLineConsumeComponent } from 'app/home/paraEmpresas/consume/move/content.component';
import { WelComeComponent } from 'app/home/paraEmpresas/consume/welcome/content.component';
import { MoveLineConfirmationComponent } from 'app/home/paraEmpresas/consume/move/content.confirmation.component';
import { EditQuotaLinesComponent } from 'app/home/paraEmpresas/consume/editQuotaLines/content.component';
import { EditQuotaLinesComponentData } from 'app/home/paraEmpresas/consume/data/editQuotaLines/content.component';
import { EditQuotaLinesComponentData5G } from 'app/home/paraEmpresas/consume/data5G/editQuotaLines/content.component';
import { EditNotifLinesComponent } from 'app/home/paraEmpresas/consume/data/editNotifConsLines/content.component';
import { SmsNotificationComponent } from 'app/home/paraEmpresas/consume/voice/smsNotification/content.component';
import { SaveConfirmationComponent } from 'app/home/paraEmpresas/consume/save/content.confirmation.component'
import { ConsumeVoiceMonetaryComponent } from 'app/home/paraEmpresas/consume/voice/voiceMonetary/content.component';
import { EditBatchQuotaComponent } from '../app/home/paraEmpresas/consume/batch/content.component';
//BLOCK
import { BlockComponent } from 'app/home/paraEmpresas/block/content.component';
import { ConfigureBlockingModalComponent } from 'app/home/paraEmpresas/block/configure/content.component';
import { DataBlockComponent } from 'app/home/paraEmpresas/block/data/content.component';
import { DataBlockTopUpComponent } from 'app/home/paraEmpresas/block/haring/content.component';
import { DataBlockVivoUpModalComponent } from 'app/home/paraEmpresas/block/haring/configure/content.component';

import { VoiceBlockComponent } from 'app/home/paraEmpresas/block/voice/content.component';
import { ConfigBlockVoiceComponent }  from 'app/home/paraEmpresas/block/voice/config/content.component';
import { ConfigGroupBlockVoiceComponent }  from 'app/home/paraEmpresas/block/voice/configGroup/content.component';
import { VoiceTableBlockComponent } from 'app/home/paraEmpresas/block/voice/tableVoice/content.component';
import { ModalBloqueioVozComponent } from 'app/home/paraEmpresas/block/voice/blockModal/content.component';
import { ModalTimeOut } from 'app/home/paraEmpresas/modaltimeout/content.component';
import { ConfirmMassiveBlockConfigurationComponent } from './home/paraEmpresas/block/voice/config/confirm/content.component';
//PACKAGES
import { PackagesComponent } from 'app/home/paraEmpresas/packages/content.component';
import { HirePackageModalComponent } from 'app/home/paraEmpresas/packages/hire/content.component';
import { RemoveLineModalComponent } from 'app/home/paraEmpresas/packages/removeLine/content.component';
//CALENDAR
import { CalendarComponent } from 'app/home/paraEmpresas/calendar/content.component';
import { ChangeCalendarConfigModalComponent } from 'app/home/paraEmpresas/calendar/changeConfig/content.component';
import { RemoveCalendarModalComponent } from 'app/home/paraEmpresas/calendar/remove/content.component';
import { RemoveSpecialDayComponent } from 'app/home/paraEmpresas/calendar/removeSpecialDay/content.component';
import { SetCalendarModalComponent } from 'app/home/paraEmpresas/calendar/set/content.component';
import { UnsetCalendarModalComponent } from 'app/home/paraEmpresas/calendar/unset/content.component';


// VIVOSYNC
import { VivoSyncComponent } from 'app/home/paraEmpresas/vivosync/content.component';
import { SyncListComponent } from 'app/home/paraEmpresas/vivosync/synclist/content.component';
import { ConfigureSyncModalComponent } from 'app/home/paraEmpresas/vivosync/configure/content.component';
import { CanEnterSyncGuard } from 'app/home/paraEmpresas/header/canentersyncguard/content.component';
//REPORTS
import { ReportsComponent } from 'app/home/paraEmpresas/reports/content.component';
import { ConsumptionReportComponent } from 'app/home/paraEmpresas/reports/consumption/content.component';
import { OperationsReportComponent } from 'app/home/paraEmpresas/reports/operations/content.component';
import { CallHistoryReportComponent } from 'app/home/paraEmpresas/reports/callHistory/content.component';
import { ConsumeVoiceHibridComponent } from 'app/home/paraEmpresas/consume/voice/voiceHibrid/content.component';
import { ConsumeVoiceMinuteComponent } from 'app/home/paraEmpresas/consume/voice/voiceMinute/content.component';
import { BlockReportComponent } from 'app/home/paraEmpresas/reports/block/content.component';
import { VivoSyncReportComponent} from 'app/home/paraEmpresas/reports/vivosync/content.component';
import { ReportDownloadService } from './services/report.download.service';
import {ProcAsyncReportComponent} from 'app/home/paraEmpresas/reports/procasync/content.component';

//MODAL
import { PackageHireModalComponent } from 'app/home/paraEmpresas/consume/welcome/packageHire/content.component';
import { HibridModalComponent } from 'app/home/paraEmpresas/consume/welcome/hibridModal/content.component';

import { LightboxModule } from 'angular2-lightbox';
import { MensagemComponent } from './home/paraEmpresas/mensagem/mensagem.component';
import { GoogleTagManagerService } from './services/google-tag-manager.service';
import { CanLeaveSyncGuard } from './home/paraEmpresas/vivosync/canleavesyncguard/content.component';
import { ConfigureSyncLeavePage } from './home/paraEmpresas/vivosync/configureLeavePage/content.component';
import { ModalReportComponent } from './utils/modals/report/content.component';



@NgModule({
  
  imports: [ BrowserModule,LightboxModule,
      HttpModule,
     NgbModule.forRoot(),
     ALL_ROUTES,
     JsonpModule,
     FormsModule,
     ReactiveFormsModule            
  ],  
  declarations:[
    MensagemComponent,
    MaskCurrencyDirective,
    MainComponent,
    NgbAlert,
    BreadcrumbComponent,
    HeaderComponent,
    AdministrationComponent,
    SaveConsumeComponent,
    RemoveGroupConsumeComponent,
    MoveLineConsumeComponent,
    ListAdministratorComponent,
    RemoveAdministratorComponent,
    EditAdministratorComponent,
    ConsumeComponent,
    FooterComponent,
    BlockComponent,
    ConfigureBlockingModalComponent,
    ModalTimeOut,
    PackagesComponent,
    HirePackageModalComponent,
    HibridModalComponent,
    RemoveLineModalComponent,
    CalendarComponent,
    RemoveCalendarModalComponent,
    SetCalendarModalComponent,
    UnsetCalendarModalComponent,
    ChangeCalendarConfigModalComponent,
    ReportsComponent,
    ConsumptionReportComponent,
    BlockReportComponent,
    OperationsReportComponent,
    CallHistoryReportComponent,
    MoveLineConfirmationComponent,
    LoginComponent,
    WelComeComponent,
    SaveConfirmationComponent,
    EditQuotaLinesComponent,
    EditQuotaLinesComponentData,
    EditQuotaLinesComponentData5G,
    EditNotifLinesComponent,
    StepsComponent,
    DataBlockComponent,
    DataBlockTopUpComponent,
    VoiceBlockComponent,
    ConfigBlockVoiceComponent,
    ConfigGroupBlockVoiceComponent,
    VoiceTableBlockComponent,
    LoadingComponent,
    ModalBloqueioVozComponent,
    ConsumeDataComponent,
    ConsumeDataComponent5G,
    ConsumeVoiceMinuteComponent,
    ConsumeVoiceMonetaryComponent,
    ConsumeVoiceHibridComponent,
    SmsNotificationComponent,
    Mobilesearch,
    RemoveSpecialDayComponent,
    VivoSyncComponent,
    SyncListComponent,
    VivoSyncReportComponent,
    ProcAsyncReportComponent,
    
    DataBlockVivoUpModalComponent,
    AbbreviatedDialingComponent,
    RemoveServiceMemberComponent,
    ConfirmMassiveBlockConfigurationComponent,
    PackageHireModalComponent,
    EditBatchQuotaComponent,
    ConfigureSyncModalComponent,
    ConfigureSyncLeavePage,
    ModalReportComponent 
  ],
  
  bootstrap:[
    MainComponent 
  ],
  
  schemas:[ 
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA ],

  entryComponents: [
    MoveLineConsumeComponent,
    RemoveAdministratorComponent,
    RemoveGroupConsumeComponent,
    EditAdministratorComponent,
    SaveConsumeComponent,
    ConfigureBlockingModalComponent,
    ModalTimeOut,
    RemoveCalendarModalComponent,
    RemoveSpecialDayComponent,
    SetCalendarModalComponent,
    UnsetCalendarModalComponent,
    HirePackageModalComponent,
    HibridModalComponent,
    ChangeCalendarConfigModalComponent,
    MoveLineConfirmationComponent,
    WelComeComponent,
    Mobilesearch,
    SaveConfirmationComponent,
    EditQuotaLinesComponent,
    EditQuotaLinesComponentData,
    EditQuotaLinesComponentData5G,
    EditNotifLinesComponent,
    LoadingComponent,
    ModalBloqueioVozComponent,
    SmsNotificationComponent, 
    DataBlockVivoUpModalComponent, 
    AbbreviatedDialingComponent,
    RemoveServiceMemberComponent,
    ConfirmMassiveBlockConfigurationComponent,
    PackageHireModalComponent,
    EditBatchQuotaComponent,
    ConfigureSyncModalComponent,
    ConfigureSyncLeavePage,
    ModalReportComponent
  ],
  providers:[ 
    GoogleTagManagerService,
    ReactiveFormsModule, 
    AlertService, 
    BindComponentService, 
    NgbAlert, 
    NgbActiveModal, 
    AuthenticationService, 
    AdministrationService, 
    ConsumeService, 
    GroupService, 
    BlockGroupService, 
    PackagesService, 
    CalendarService, 
    HeaderComponent, 
    AdministrationComponent, 
    ListAdministratorComponent, 
    ConsumeComponent, 
    RemoveAdministratorComponent, 
    EditAdministratorComponent, 
    PackagesComponent, 
    HirePackageModalComponent,
    HibridModalComponent,
    ConsumeVoiceMinuteComponent,
    ConsumeVoiceMonetaryComponent,
    ConsumeVoiceHibridComponent, 
    RemoveLineModalComponent, 
    MoveLineConfirmationComponent, 
    ConsumptionReportComponent, 
    BlockReportComponent, 
    OperationsReportComponent, 
    CallHistoryReportComponent,ReportsComponent, 
    StepsComponent, 
    ConsumptionReportService, 
    OperationsReportService, 
    CallHistoryReportService,VoiceConsumeService, 
    OfferBannerService, 
    RemoveServiceMemberComponent,  
    ConfirmMassiveBlockConfigurationComponent, 
    VivoSyncService,
    ProcAsyncReportService,
    CanLeaveSyncGuard,
    CanEnterSyncGuard,
    ReportDownloadService,
    {provide: NgbDateParserFormatter, 
      useClass: CustomNgbDateParserFormatter}, 
    {provide: NgbDatepickerI18n, 
      useClass: CustomNgbDatepickerI18n 
      }
    ],
    exports: [ 
      MaskCurrencyDirective,
    ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts